<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-3">Report Configurator</div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="col-3" style="padding: 1%;">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportTableId"
                    (change)="onReportTableChange($event.target.selectedIndex)">
              <option *ngFor="let reportTable of reportTableListArray" [value]="reportTable.type">{{reportTable.view}}</option>
            </select>
        </div>
    </div>
    <div class="col-3" style="padding: 1%;">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="reportTypeSelected"
                    (change)="onReportTypeChange($event.target.selectedIndex)">
              <option *ngFor="let reportTypeObj of reportTypeObjArray" [value]="reportTypeObj.type">{{reportTypeObj.view}}</option>
            </select>
        </div>
    </div>
    <div *ngIf="graphReport" class="col-3" style="padding: 1%;">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="reportGraphTypeSelected"
                    (change)="onReportGraphTypeChange($event.target.selectedIndex)">
              <option *ngFor="let reportGraphTypeObj of reportGraphTypeObjArray" [value]="reportGraphTypeObj.type">{{reportGraphTypeObj.view}}</option>
            </select>
        </div> 
    </div>
    <div class="col-3" style="padding: 1%;">
        <input type="text" class="form-control font-13" [(ngModel)]="templateName" placeholder="Enter template name">
    </div>
    <div class="col-3" style="padding: 1%;">
      <button  type="button" class="btn btn-success radius-0" (click)="saveTemplate()">Save As Template</button>
    </div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="col-md-4">
      <div class="views-title">
        Columns
      </div>
      <div class="views-body">
          <div class="row">
            <!-- <input type="text" class="form-control font-13" placeholder="Enter column name"> -->
          </div>
          <div class="row">
              <mat-selection-list class="list-section-col" [(ngModel)]="selectedColums" (ngModelChange)="onColumsChange($event)">
                  <mat-list-option *ngFor="let columnObj of columnObjArray" [value]="columnObj">
                      {{columnObj.column_name}}
                    </mat-list-option>
                </mat-selection-list>
          </div>
        
        <br>
      </div>
    </div>
    <div  class="col-md-8">
      <angular-slickgrid gridId='common-grid'
                          (onAngularGridCreated)="angularGridReady($event)"
                          [columnDefinitions]="columnDefinitions"
                          [gridOptions]="gridOptions"
                          [dataset]="selectedColumnObjArray"
                          (sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
                          (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
      >
      </angular-slickgrid>
      
    </div>
  </div>

  <ng-template #content>
      <div class="modal-header modalTitle1">
        <div class="modal-title">Report Filter</div>
    
      </div>
      <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

        <div *ngIf="selectedFilterType === 'TIMESTAMP'" class="row header mar-lft-rgt-0 ">
            <div class="form-group col-sm-6" >
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="operatorSelected" 
                              (change)="onOperatorChange($event.target.selectedIndex)">
                  <option *ngFor="let timeStampOperator of timeStampOperatorList" [value]="timeStampOperator.operator">{{timeStampOperator.view}}</option>
                </select>
            </div>
          <div *ngIf="viewFromDate" class="form-group col-sm-3">
            <input [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9" class="form-control radius-0 font-13"
                    [(ngModel)]="fromDate" placeholder='From Date'>
            <owl-date-time [pickerType]="'calendar'" #dt9></owl-date-time>
          </div>
          <div *ngIf="viewToDate" class="form-group col-sm-3 mar-bot-10">
            <input [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10" class="form-control radius-0 font-13"
                    [(ngModel)]="toDate" placeholder='To Date'>
            <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
          </div>
        </div>
        <div *ngIf="selectedFilterType === 'VARCHAR' || selectedFilterType === 'TEXT'" class="row header mar-lft-rgt-0 ">
            <div class="form-group col-sm-6">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedVarcharOperator"
                        (change)="onchangeVarcharOperator($event.target.selectedIndex)">
                  <option *ngFor="let varcharOperator of varcharOperatorList" [value]="varcharOperator.operator">{{varcharOperator.view}}</option>
                </select>
            </div>
            <div *ngIf="selectedVarcharOperator === 'dropdown'" class="form-group col-sm-6">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedFilter"
                        (change)="onFilterChange($event.target.selectedIndex)">
                  <option *ngFor="let selectedFilterObj of selectedFilterObjArray" [value]="selectedFilterObj.uniqueField">{{selectedFilterObj.uniqueField}}</option>
                </select>
            </div>
            <div *ngIf="selectedVarcharOperator !== 'dropdown'" class="form-group col-sm-6">
              <input type="text" class="form-control font-13" [(ngModel)]="filterValue" placeholder="Enter Filter Value">
            </div>
        </div>
        
    
        <!-- <div *ngIf="selectedFilterType === 'TIMESTAMP'" class="form-group">
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="selectedFilterValue"
                 placeholder="Enter Report Filter">
        </div> -->
    
      </div>
      <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="saveReportFilter()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="close()">Cancel</button>
      </div>
    </ng-template>

</div>

